export const changeClusterNameReducer = (state = "Ajaj", action) => {
  switch (action.type) {
    case "CHANGE_CLUSTER_NAME":
      return action.payload.clusterName;
    default:
      return state;
  }
};
